import { motion } from "framer-motion";

const TESTIMONIALS = [
  {
    quote: "Trước mất cả buổi tổng hợp điểm danh cuối tháng. Giờ 5 phút có báo cáo đầy đủ.",
    name: "Nguyễn Thị Hương",
    role: "Giám đốc, TT Anh ngữ Sunrise",
  },
  {
    quote: "Học sinh nộp bài đúng hạn nhiều hơn hẳn. Chấm điểm cũng nhanh hơn 3 lần.",
    name: "Lê Văn Đức",
    role: "Giáo viên Toán, TT Luyện thi 123",
  },
  {
    quote: "Biết ngay con có mặt hay vắng khi buổi học bắt đầu, không cần gọi thầy cô.",
    name: "Trần Minh Quân",
    role: "Phụ huynh lớp 9",
  },
  {
    quote: "Thông báo hàng loạt tiết kiệm vài giờ mỗi tuần. Phụ huynh hài lòng hẳn.",
    name: "Phạm Thu Hà",
    role: "Quản lý, TT Tiếng Anh BrightKids",
  },
  {
    quote: "Quản lý học phí trực quan, không còn nhầm lẫn. Đối soát cuối tháng dễ thở.",
    name: "Đặng Quốc Khánh",
    role: "Chủ TT Toán tư duy",
  },
];

export function LandingTestimonials() {
  const items = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.5, type: "spring", stiffness: 100, damping: 20 }}
      className="bg-slate-50 dark:bg-slate-950/60"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-24">
        <div className="max-w-2xl mb-10">
          <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-slate-900 dark:text-white">
            Họ đã thay đổi cách vận hành
          </h2>
          <p className="mt-3 text-slate-600 dark:text-slate-400">Phản hồi từ người dùng thật.</p>
        </div>

        <div className="overflow-hidden group">
          <motion.div
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
            className="flex gap-4 group-hover:[animation-play-state:paused]"
          >
            {items.map((t, i) => (
              <div
                key={i}
                className="shrink-0 w-[340px] bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 p-6 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.05)]"
              >
                <p className="text-sm text-slate-700 dark:text-slate-200 leading-relaxed">"{t.quote}"</p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="size-10 rounded-full bg-slate-100 dark:bg-slate-800 grid place-items-center text-sm font-semibold text-slate-600 dark:text-slate-400">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-medium text-sm text-slate-900 dark:text-white">{t.name}</div>
                    <div className="text-xs text-slate-500 dark:text-slate-400">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}
